import { useFlippers } from "../useFlippers";
import { useSharedGlobalConfig } from "../useSharedGlobalConfig";

const useCallistoPracOnboardingExperiment = () => {
  const [isPracOnboardingEnabled] = useFlippers("callisto_prac_onboarding_2023Q4_experiment");
  const { isEmerson } = useSharedGlobalConfig();

  return isPracOnboardingEnabled && !isEmerson;
};

export { useCallistoPracOnboardingExperiment };
